module.exports = __webpack_public_path__ + "static/img/bottom_logo.f6b504b9.png";